module.exports = __webpack_public_path__ + "static/media/picture-(80).12a5fa77.JPG";